import React, { useState } from "react"
import { connect } from "react-redux"
import { Tabs, Tooltip, Button } from "antd"
import { ToastMessage, NOTIFICATION_TYPES } from "../Notification/Notifications"
import {
  PlusOutlined,
  MinusOutlined,
  ClockCircleOutlined,
  DislikeFilled,
  LikeFilled,
  QuestionOutlined,
  CheckOutlined,
} from "@ant-design/icons"
import RightArrowBend from "../CartPopup/RightArrowBend"
import "./Menu.scss"
import {
  getRestaurantMenu,
  whichItemAreSuggested,
  resetWhichItemsAreSuggested,
  removeItemFromCart,
  toggleAddToCartItem,
  getTheCartFromDelivery,
  saveSuggestionEvent,
} from "../../redux/actionCreators/planDinnner"
import _ from "../../utils/lodashUtils"
import { MenuItem } from "../MenuItem/MenuItem"
import {
  FirebaseContext,
  FIREBASE_STATE_KEYS,
  FirebaseService,
} from "../../firebase"
import { usePrevious } from "common-custom-hooks"
import { SUGGESTION_STATES } from "../../constants/commons"
import {
  consolidateItemQuantityInCart,
  isPartnerAway,
  getPartnerNameorNickName,
} from "../../utils/helpers"
import {
  PARTNER_SUGGESTED_YOU,
  YOU_SUGGESTED_MENU,
  MENU_SUGGESTION_ACCEPTED,
  MENU_SUGGESTION_DECLINED,
  REJECTED,
  ACCEPTED,
  PENDING,
  ORDERED,
  SUGGEST_TO,
  SUGGESTED_THIS,
  ADD_TO_MINE,
} from "../../constants/messages"
import { ActivityIndicator } from "../ActivityIndicator"
import { TextTag as Text } from "../../atoms"

const { TabPane } = Tabs

const Menu = props => {
  const {
    getRestaurantMenu,
    getTheCartFromDelivery,
    toggleAddToCartItem,
    deliveryDotComCart,
    removeItemFromCart,
    showAddToCartPopup,
    updateCartPopup,
    user,
    partner,
    addingRemovingItemFromCart,
  } = props

  const { dateState, partnerState, userState } = React.useContext(
    FirebaseContext
  )
  const partnerName = getPartnerNameorNickName(partnerState, partner)
  const partnerOnline = _.get(partnerState, "presence.isOnline", false)
  const partnerScreen = _.get(partnerState, "activeScreen", "")
  const partnerAway = isPartnerAway(partnerScreen, partnerOnline)
  const acceptedRestaurant = _.get(
    dateState,
    FIREBASE_STATE_KEYS.ACCEPTED_RESTAURANT,
    {}
  )

  const previousAcceptedRestaurant = usePrevious(acceptedRestaurant)

  const restaurantMenu = acceptedRestaurant.menus

  const partnerCart = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.DELIVERY_COM_CART,
    {}
  )
  const userCart = _.get(userState, FIREBASE_STATE_KEYS.DELIVERY_COM_CART, {})

  const partnerCartItems = consolidateItemQuantityInCart(partnerCart.cart)
  const userCartItems = consolidateItemQuantityInCart(userCart.cart)
  let userSuggestions = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )

  React.useEffect(() => {
    const acceptedRestaurantId =
      acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID]
    //get cart items
    if (
      acceptedRestaurantId &&
      !_.isEqual(previousAcceptedRestaurant, acceptedRestaurant)
    ) {
      getRestaurantMenu(acceptedRestaurantId)
      getTheCartFromDelivery(acceptedRestaurantId)
    }
  }, [acceptedRestaurant])

  const showAddToCartModal = item => {
    toggleAddToCartItem(true, item)
  }

  const handleSuggestClick = async item => {
    const suggestion = {
      [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: SUGGESTION_STATES.PENDING,
      item,
    }
    // add to user's suggestedToPartner key.
    const path = `${user.uuid}/${[FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER]}`
    // Adding an item to suggestions list.
    userSuggestions[item.id] = suggestion
    const partnerCartNotificationPath = `${partner.uuid}/${FIREBASE_STATE_KEYS.CART_NOTIFICATION}`
    await FirebaseService.patch(
      {
        [path]: userSuggestions,
        [partnerCartNotificationPath]: {
          [FIREBASE_STATE_KEYS.INDICATOR]: true,
          [FIREBASE_STATE_KEYS.MESSAGE]: PARTNER_SUGGESTED_YOU(
            _.get(user, "display_name", "")
          ),
          [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
          [FIREBASE_STATE_KEYS.SHOULD_OPEN_CART]: true,
        },
      },
      FirebaseService.getDefaultPath()
    )

    // set notification indicator for self
    ToastMessage({
      type: NOTIFICATION_TYPES.INFO,
      message: YOU_SUGGESTED_MENU,
    })
  }

  const handleClosePopup = () => {
    toggleAddToCartItem(false, {})
  }

  const isItemInPartnersCart = item => {
    return (
      partnerCartItems.filter(partnerCartItem => partnerCartItem.id === item.id)
        .length > 0
    )
  }
  const isItemInUserCart = item => {
    return (
      userCartItems.filter(partnerCartItem => partnerCartItem.id === item.id)
        .length > 0
    )
  }

  const isPendingSuggestedByPartner = item => {
    return _.get(
      partnerState,
      `${FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER}.${item.id}.${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
    ) === SUGGESTION_STATES.PENDING
      ? true
      : false
  }

  const hasPartnerAddedSuggestionToCard = item => {
    const isAcceptedSuggestion =
      _.get(
        userState,
        `${FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER}.${item.id}.${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
      ) === SUGGESTION_STATES.ACCEPTED

    const isInPartnersCart = isItemInPartnersCart(item)
    return isAcceptedSuggestion && isInPartnersCart
  }
  let itemsInCart = {}
  deliveryDotComCart.forEach(cartItem => (itemsInCart[cartItem.id] = cartItem))

  const getItemQuantityInCart = item => {
    let quantity = 0
    deliveryDotComCart.forEach(cartItem => {
      if (cartItem.id === item.id || cartItem.name === item.name) {
        quantity += cartItem.quantity
      }
    })
    return quantity
  }
  const onSuccess = () => {
    FirebaseService.write(
      true,
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${
        FIREBASE_STATE_KEYS.UNREAD_NOTIFICATION
      }`
    )
  }

  const onAddItemToCart = item => () => showAddToCartModal(item)
  const onRemoveItemFromCart = (item, restaurantId) => () =>
    removeItemFromCart(item, restaurantId)
  const onSuggestItem = item => async () => await handleSuggestClick(item)
  const onAcceptSuggestion = item => async hidePopup => {
    const payload = {
      item,
      [FIREBASE_STATE_KEYS.SUGGESTION_STATE]: SUGGESTION_STATES.ACCEPTED,
    }

    // update in user's suggestedToPartner key.
    await FirebaseService.patch(
      { [item.id]: payload },
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${
        FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER
      }`
    )
    if (!hidePopup) {
      showAddToCartModal(item, "+")
    }
    // set notification indicator for partner
    await FirebaseService.patch(
      {
        [FIREBASE_STATE_KEYS.INDICATOR]: true,
        [FIREBASE_STATE_KEYS.MESSAGE]: MENU_SUGGESTION_ACCEPTED,
        [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
      },
      `${FirebaseService.getDefaultPath()}${partner.uuid}/${
        FIREBASE_STATE_KEYS.CART_NOTIFICATION
      }`
    )
    const suggestedValue = {
      suggestedBy: partner.username,
      suggestedTo: user.username,
      type: "menu",
      id: acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      menu: item.name,
      isAccepted: true,
      partner1Location: _.get(partner.address, "user_address"),
      partner2Location: _.get(user.address, "user_address"),
      date: new Date(),
    }
    props.saveSuggestionEvent(suggestedValue, onSuccess)
  }
  const onRejectSuggestion = item => async () => {
    const partnerSuggestionPath = `${partner.uuid}/${FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER}/${item.id}/${FIREBASE_STATE_KEYS.SUGGESTION_STATE}`
    const partnerCartNotificationPath = `${partner.uuid}/${FIREBASE_STATE_KEYS.CART_NOTIFICATION}`
    // update in user's suggestedToPartner key.
    await FirebaseService.patch({
      [partnerSuggestionPath]: SUGGESTION_STATES.REJECTED,
      [partnerCartNotificationPath]: {
        [FIREBASE_STATE_KEYS.INDICATOR]: true,
        [FIREBASE_STATE_KEYS.MESSAGE]: MENU_SUGGESTION_DECLINED,
        [FIREBASE_STATE_KEYS.TIMESTAMP]: Date.now(),
      },
    })
    const suggestedValue = {
      suggestedBy: partner.username,
      suggestedTo: user.username,
      type: "menu",
      id: acceptedRestaurant[FIREBASE_STATE_KEYS.RESTAURANT_ID],
      menu: item.name,
      isAccepted: false,
      partner1Location: _.get(partner.address, "user_address"),
      partner2Location: _.get(user.address, "user_address"),
      date: new Date(),
    }
    props.saveSuggestionEvent(suggestedValue, onSuccess)
  }

  const mySuggestions = _.get(
    userState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )
  const partnerSuggestions = _.get(
    partnerState,
    FIREBASE_STATE_KEYS.SUGGESTED_TO_PARTNER,
    {}
  )

  return (
    <div id="RestaurantMenu">
      {showAddToCartPopup ? (
        <MenuItem
          closePopup={handleClosePopup}
          onRejectSuggestion={onRejectSuggestion}
          isSuggested={isPendingSuggestedByPartner}
        />
      ) : null}
      {restaurantMenu && (
        <Tabs defaultActiveKey="0">
          {!_.isEmpty(Object.keys(restaurantMenu)) &&
            Object.keys(restaurantMenu).map((el, index) => (
              <TabPane
                tab={_.get(restaurantMenu, [el, "name"], "")}
                key={index}
                className="menu-items-wrapper"
              >
                {!_.isEmpty(restaurantMenu[el].children) &&
                  restaurantMenu[el].children.map((item, itemIndex) => (
                    <div
                      key={itemIndex}
                      className={`menu-item ${
                        isPendingSuggestedByPartner(item)
                          ? "partner-suggested"
                          : ""
                      } ${
                        getItemQuantityInCart(item) > 0
                          ? "partner-added-to-cart"
                          : ""
                      }`}
                    >
                      <section
                        className={`menu-item-label ${
                          isPendingSuggestedByPartner(item)
                            ? "partner-suggested"
                            : ""
                        } ${
                          getItemQuantityInCart(item) > 0
                            ? "partner-added-to-cart"
                            : ""
                        }`}
                      >
                        <Text textType="sectionHeading">{item.name}</Text>
                        <Text textType="sectionTextPrimary">
                          $ {item.price}
                        </Text>
                        <Text textType="sectionTextPrimary">
                          {_.get(item, "description", "")}
                        </Text>
                      </section>
                      <section className="menu-item-actions">
                        <CartControls
                          item={item}
                          itemsInCart={itemsInCart}
                          onAdd={onAddItemToCart(item)}
                          onRemove={onRemoveItemFromCart(
                            item,
                            acceptedRestaurant[
                              FIREBASE_STATE_KEYS.RESTAURANT_ID
                            ]
                          )}
                          onAccept={() => {
                            //Adding item will make suggestion accepted
                            showAddToCartModal(item)
                          }}
                          onReject={onRejectSuggestion(item)}
                          onAcceptSuggestion={onAcceptSuggestion(item)}
                          isSuggested={isPendingSuggestedByPartner(item)}
                          itemQuantity={getItemQuantityInCart(item)}
                          partnerName={partnerName}
                          isItemInUserCart={item && isItemInUserCart(item)}
                          partnerSuggestions={partnerSuggestions}
                          addingRemovingItemFromCart={
                            addingRemovingItemFromCart
                          }
                        />
                        <SuggestionButton
                          mySuggestions={mySuggestions}
                          item={item}
                          partnerAway={partnerAway}
                          handleSuggestClick={onSuggestItem(item)}
                          isItemInPartnersCart={
                            item && isItemInPartnersCart(item)
                          }
                          partnerName={partnerName}
                        />
                      </section>
                    </div>
                  ))}
              </TabPane>
            ))}
        </Tabs>
      )}
    </div>
  )
}

//tooltip for all buttons in menu
const tooltipWrapper = (children, text) => {
  return (
    <Tooltip placement="rightTop" title={text}>
      {children}
    </Tooltip>
  )
}

const SuggestionButton = props => {
  const {
    mySuggestions,
    item,
    handleSuggestClick,
    isItemInPartnersCart,
    partnerAway,
    partnerName,
  } = props
  const itemInMySuggestions = _.get(mySuggestions, `${item.id}`, {})
  const acceptedSuggestion =
    itemInMySuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.ACCEPTED
  const pendingSuggestion =
    itemInMySuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.PENDING
  if (itemInMySuggestions) {
    const renderAccept = (
      <section className="suggestion accepted" disabled={true}>
        {tooltipWrapper(<LikeFilled />, ACCEPTED)}
      </section>
    )
    const renderRejected = (
      <section className="suggestion rejected" disabled={true}>
        {tooltipWrapper(<DislikeFilled />, REJECTED)}
      </section>
    )
    if (
      itemInMySuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
        SUGGESTION_STATES.ACCEPTED &&
      isItemInPartnersCart
    ) {
      return renderAccept
    } else if (
      itemInMySuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
      SUGGESTION_STATES.REJECTED
    ) {
      return renderRejected
    } else if (acceptedSuggestion) {
      return renderAccept
    } else if (
      itemInMySuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
      SUGGESTION_STATES.PENDING
    ) {
      return (
        <section className="suggestion pending" disabled={true}>
          {tooltipWrapper(<ClockCircleOutlined />, PENDING)}
        </section>
      )
    }
  }
  if (isItemInPartnersCart) {
    return (
      <section className="suggestion partner-added" disabled={true}>
        {tooltipWrapper(<CheckOutlined />, ORDERED(partnerName))}
      </section>
    )
  }
  const suggestButton = (
    <Button
      className="suggestion-btn pristine"
      onClick={handleSuggestClick}
      disabled={partnerAway}
      icon={<RightArrowBend />}
    ></Button>
  )
  return partnerAway ? suggestButton : tooltipWrapper(suggestButton, SUGGEST_TO)
}

const CartControls = props => {
  const [isHidden, toggleIshidden] = useState(false)
  const [isHiddenbtns, toggleIshiddenbtns] = useState(false)

  const showAcceptBtn = () => {
    let value = isHidden
    toggleIshidden(!value)
  }
  const addRemoveBtn = () => {
    let value = isHiddenbtns
    toggleIshiddenbtns(!value)
  }

  const {
    isSuggested,
    item,
    itemsInCart,
    onAdd,
    onRemove,
    onReject,
    onAccept,
    onAcceptSuggestion,
    itemQuantity,
    partnerName,
    partnerSuggestions,
    isItemInUserCart,
    addingRemovingItemFromCart,
  } = props
  const itemInPartnerSuggestions = _.get(partnerSuggestions, `${item.id}`, {})
  const acceptedSuggestion =
    itemInPartnerSuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.ACCEPTED
  const rejectedSuggestion =
    itemInPartnerSuggestions[FIREBASE_STATE_KEYS.SUGGESTION_STATE] ===
    SUGGESTION_STATES.REJECTED
  const infoText = SUGGESTED_THIS(partnerName)
  if (acceptedSuggestion && !isItemInUserCart && !addingRemovingItemFromCart) {
    onReject()
  }
  if (rejectedSuggestion && isItemInUserCart && !addingRemovingItemFromCart) {
    onAcceptSuggestion(true)
  }
  const pendingCartRequest =
    addingRemovingItemFromCart && item.id === addingRemovingItemFromCart.item_id

  if (isSuggested) {
    return (
      <section
        className={`cart-controls suggested ${
          isHidden ? "display-suggestion-response" : ""
        }`}
      >
        <section className={`suggestion-response ${isHidden ? "" : "hideBtn"}`}>
          <button className="suggestion-response-btn accept" onClick={onAccept}>
            <LikeFilled />
          </button>
          <button className="suggestion-response-btn reject" onClick={onReject}>
            <DislikeFilled />
          </button>
        </section>
        <div className="info" onClick={showAcceptBtn}>
          {tooltipWrapper(<QuestionOutlined />, infoText)}
        </div>
      </section>
    )
  } else {
    return itemsInCart[item.id] ? (
      <section
        className={`modify-items ${
          isHiddenbtns ? "display-add-remove-btns" : ""
        }`}
      >
        <div className={`add-remove-btn ${isHiddenbtns ? "" : "hideBtn"}`}>
          <button
            className="add-menu-item"
            onClick={onAdd}
            disabled={pendingCartRequest}
          >
            <PlusOutlined />
          </button>
          <button
            className="remove-menu-item"
            onClick={onRemove}
            disabled={pendingCartRequest}
          >
            <MinusOutlined />
          </button>
        </div>
        <span className="item-count" onClick={addRemoveBtn}>
          {pendingCartRequest ? (
            <ActivityIndicator styles={{ color: "#fff" }} />
          ) : (
            itemQuantity
          )}
        </span>
      </section>
    ) : (
      <button
        className="add-menu-item"
        disabled={pendingCartRequest}
        onClick={onAdd}
      >
        {pendingCartRequest ? (
          <ActivityIndicator styles={{ color: "#fff" }} />
        ) : (
          tooltipWrapper(<PlusOutlined />, ADD_TO_MINE)
        )}
      </button>
    )
  }
}

const mapStateToProps = state => {
  return {
    deliveryDotComCart: _.get(state, "planDinner.deliveryDotComCart.cart", []),
    user: _.get(state, "auth.user", {}),
    partner: _.get(state, "auth.partner", {}),
    showAddToCartPopup: state.planDinner.showAddToCartPopup,
    updateCartPopup: state.planDinner.isUpdate,
    addingRemovingItemFromCart: _.get(
      state,
      "loadingState.itemOperationLoading"
    ),
  }
}

export default connect(mapStateToProps, {
  getRestaurantMenu,
  whichItemAreSuggested,
  resetWhichItemsAreSuggested,
  removeItemFromCart,
  toggleAddToCartItem,
  getTheCartFromDelivery,
  saveSuggestionEvent,
})(Menu)
